import VolumeDiscountsError from './volumeDiscountsError';
class VolumeDiscountInvalidId extends VolumeDiscountsError {
    crowdfundingPropertyId;
    constructor(crowdfundingPropertyId, options) {
        super('The crowdfunding property id is invalid', options);
        this.crowdfundingPropertyId = crowdfundingPropertyId;
    }
}
export default VolumeDiscountInvalidId;
